module.exports = __webpack_public_path__ + "static/media/MongoDB.8aad4da2.svg";